import { render, staticRenderFns } from "./Joius.vue?vue&type=template&id=ad235bb8&scoped=true&"
import script from "./Joius.vue?vue&type=script&lang=js&"
export * from "./Joius.vue?vue&type=script&lang=js&"
import style0 from "./Joius.vue?vue&type=style&index=0&id=ad235bb8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad235bb8",
  null
  
)

export default component.exports